const MetaLeadsMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    VISIBILITY: {
        id: "visibility",
        group: "settings_group",
        path: "visibility",
        label: "Visibility",
        tabs: [],
        implemented: true,
    },
    LEADS: {
        id: "leads",
        group: "leads",
        path: "leads",
        label: this?.$t("message.leads") || "Leads",
        tabs: [],
        implemented: true,
    },
    FORMS: {
        id: "forms",
        group: "leads",
        path: "forms",
        label: this?.$t("form.forms") || "Forms",
        tabs: [],
        implemented: true,
    },
    // COMMENT_SETTINGS: {
    //     id: "commentsettings",
    //     group: "settings_group",
    //     path: "commentsettings",
    //     label: "Comment Settings",
    //     tabs: [],
    //     implemented: true,
    // },
};

export default MetaLeadsMenuTypes;
